import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@blueprintjs/core';
import { UtimacoCircuitSwitchActionsType } from 'routes/UtimacoCircuitSwitch/UtimacoCircuitSwitch.types';

interface Props {
  disabled: boolean;
  context: {
    onActionMenuItemClick?: (
      e: React.MouseEvent<HTMLElement, MouseEvent>
    ) => void;
    props: {
      showActionMenuItem: boolean;
      hasPrivilegeToCreateNew: boolean;
      hasPrivilegeToDelete: boolean;
      hasPrivilegetoView: boolean;
    };
  };
}

const UtimacoCircuitSwitchListGridActionMenu: FunctionComponent<Props> = ({
  disabled,
  context: {
    onActionMenuItemClick,
    props: {
      showActionMenuItem,
      hasPrivilegetoView,
      hasPrivilegeToCreateNew,
      hasPrivilegeToDelete
    }
  }
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu>
      {hasPrivilegetoView && showActionMenuItem && (
        <MenuItem
          id={UtimacoCircuitSwitchActionsType.View}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.view')}
        />
      )}
      {hasPrivilegeToCreateNew && showActionMenuItem && (
        <MenuItem
          id={UtimacoCircuitSwitchActionsType.Edit}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.edit')}
        />
      )}
      {hasPrivilegeToDelete && showActionMenuItem && (
        <MenuItem
          id={UtimacoCircuitSwitchActionsType.Delete}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.delete')}
        />
      )}
    </Menu>
  );
};

export default UtimacoCircuitSwitchListGridActionMenu;
